export default __webpack_public_path__ + "static/media/Check4Cancer-Header-Banner_1440x300.cdce58db.jpg";